const LOAD_DATA_CANDIDATE_RESULT_TEST           = 'LOAD_DATA_CANDIDATE_RESULT_TEST'
const LOAD_DATA_CANDIDATE_RESULT_TEST_SUCCESS   = 'LOAD_DATA_CANDIDATE_RESULT_TEST_SUCCESS'
const LOAD_DATA_CANDIDATE_RESULT_TEST_FAILED    = 'LOAD_DATA_CANDIDATE_RESULT_TEST_FAILED'
const UNMOUNT_DATA_CANDIDATE_RESULT_TEST        = 'UNMOUNT_DATA_CANDIDATE_RESULT_TEST'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const candidateResultTestReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_CANDIDATE_RESULT_TEST:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_CANDIDATE_RESULT_TEST_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_CANDIDATE_RESULT_TEST_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_CANDIDATE_RESULT_TEST:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default candidateResultTestReducer;